import AxiosService from "../axios-service/AxiosService";
import Storage from "../../services/storage-service/Storage";
import ErrorHandler from "../../utils/ErrorHandler";
const managerBff = process.env.REACT_APP_MANAGER_BFF_URL;

export default class RoleService {
    static getRoles = async () => {
        let token = null;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (e) {
            ErrorHandler.handleError(e);
        }
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };
        const response = await AxiosService.httpGet(
            `${managerBff}/v1/role`,
            config
        );
        const roles = response.data.map(role => {
            if (role === "DEV") return "DEVELOPER";

            return role;
        });

        return roles;
    };

    static getRolesForClient = async () => {
        let token = null;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (e) {
            ErrorHandler.handleError(e);
        }
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };

        return await AxiosService.httpGet(`${managerBff}/v1/role`, config);
    };

    static editRole = async role => {
        let token = null;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (e) {
            ErrorHandler.handleError(e);
        }
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };
        return await AxiosService.httpPut(
            `${managerBff}/v1/role/${role.id}`,
            role,
            config
        );
    };

    static createRole = async role => {
        let token = null;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (e) {
            ErrorHandler.handleError(e);
        }
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };
        return await AxiosService.httpPost(
            `${managerBff}/v1/role/`,
            role,
            config
        );
    };

    static deleteRole = async role => {
        let token = null;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (e) {
            ErrorHandler.handleError(e);
        }
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };
        return await AxiosService.httpDelete(
            `${managerBff}/v1/role/${role.id}`,
            config
        );
    };
}
